module.exports = __webpack_public_path__ + "sml-chat-reply-icon.png?332369c27462afca1fe7240b727d2400";